export default __webpack_public_path__ + "static/media/REAL CPI ASSET STIKER-09.8058c0e6.png";